import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2d48c5',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#ff3b30',
      },
    },
  },
  icons: {
    values: {
      dropdown: 'mdi-chevron-down',
    },
  },
});
